export enum IntegrationStatus {
  PAUSED = "PAUSED",   // paused / disconnected by the user
  ACTIVE = "ACTIVE",
  FAILED = "FAILED",
  EXPIRED = "EXPIRED", // the provider revoked the authorization (Google) - the user must connect again
}

export enum IntegrationType {
  MISLAKA_PRODUCTION = "MISLAKA_PRODUCTION",
  GOOGLE_CALENDAR = "GOOGLE_CALENDAR",
  GOOGLE_EMAIL = "GOOGLE_EMAIL",
  LEAD_STREAM = "LEAD_STREAM",
  AUTO_PRE_ADVICE = "AUTO_PRE_ADVICE",
  FIREFLIES = "FIREFLIES",
  HUBSPOT = "HUBSPOT",
  DESKTOP_DOWNLOADER = "DESKTOP_DOWNLOADER",
}

export enum ConnectionStatus {
  OK = "OK",
  FAILED = "FAILED",
}

export interface TestConnectionResult {
  status: ConnectionStatus;
  reason: string;
}

export interface ActiveIntegrationDTO {
  integration_type: IntegrationType;
  status: IntegrationStatus;
  last_synced_at?: string; // ISO datetime string
}

export interface GoogleOAuthData {
  access_token: string;
  refresh_token?: string;
  expires_at?: number; // Unix timestamp
  token_type: string; // "Bearer"
  scope?: string; // למשל: "gmail.readonly calendar.readonly"
}

export class Integration {
  id?: number;
  integration_type: IntegrationType;
  integration_token?: string;
  integration_data?: Record<string, any>; // יכול להכיל GoogleOAuthData
  status: IntegrationStatus;
  agent_user_id?: number;
  last_synced_at?: string; // ISO datetime string

  constructor(init?: Partial<Integration>) {
    Object.assign(this, init);
  }

  static defaultEmpty(): Integration {
    return new Integration({
      id: undefined,
      integration_type: IntegrationType.MISLAKA_PRODUCTION,
      integration_token: undefined,
      integration_data: undefined,
      status: IntegrationStatus.PAUSED,
      agent_user_id: undefined,
      last_synced_at: undefined,
    });
  }
}
